import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { ResponsiveContainer, LineChart, Line } from "recharts";
import { Card } from "@/components/ui/card";
import { formatMetric } from "@/lib/format";

export const KpiStatCard = ({ def, value, delta, series = [] }) => {
  const showDelta = delta !== null && delta !== undefined && !isNaN(delta);
  // For inverted metrics (burn, churn) a decrease is good
  const good = showDelta ? (def.invert ? delta <= 0 : delta >= 0) : null;
  const deltaColor = good ? "text-emerald-700 bg-emerald-50 border-emerald-200" : "text-red-700 bg-red-50 border-red-200";
  const chartData = series.map((v, i) => ({ i, v: v === null || v === undefined ? null : Number(v) }));

  return (
    <Card
      data-testid={`kpi-card-${def.key}`}
      className="group rounded-xl border bg-card p-4 shadow-[var(--shadow-sm)] transition-shadow duration-200 hover:shadow-[var(--shadow-md)]"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="text-xs font-medium text-muted-foreground">{def.label}</div>
        {showDelta && (
          <span
            data-testid={`kpi-card-delta-${def.key}`}
            className={`inline-flex items-center gap-0.5 rounded-full border px-1.5 py-0.5 text-[11px] font-medium ${deltaColor}`}
          >
            {delta >= 0 ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
            {Math.abs(delta).toFixed(1)}%
          </span>
        )}
      </div>
      <div data-testid={`kpi-card-value-${def.key}`} className="h-display mt-1 text-2xl font-semibold tabular-nums text-foreground">
        {formatMetric(def.type, value)}
      </div>
      <div className="mt-2 h-9">
        {chartData.filter((d) => d.v !== null).length > 1 ? (
          <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 240, height: 36 }}>
            <LineChart data={chartData}>
              <Line type="monotone" dataKey="v" stroke="hsl(var(--chart-1))" strokeWidth={2} dot={false} isAnimationActive={false} connectNulls />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full w-full rounded bg-secondary/50" />
        )}
      </div>
    </Card>
  );
};
